export const selectCurrentUser = (state) => state.authentication.user;

export const selectCurrentToken = (state) => state.authentication.token;

export const selectCurrentRefreshToken = (state) => state.authentication.refreshToken;

export const selectTokenExpiryDate = (state) => state.authentication.expiry;